import FragmentSummary from "./fragment-summary";
import Rush from "./rush";

export default class FieldGoalFakeRun extends Rush {
    summarize(summaryContext, stringifier) {
        const message = `, ${stringifier.firstInitial(
            this.rushedBy
        )} faked and ran for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.fieldPosition
        )}`;

        return new FragmentSummary(message);
    }

    getScoringPoints(gameConfig) {
        return gameConfig.scoring.runPAT;
    }
}
